import { render, staticRenderFns } from "./HabitHolder.vue?vue&type=template&id=8a8bb686&scoped=true&"
import script from "./HabitHolder.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HabitHolder.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HabitHolder.vue?vue&type=style&index=0&id=8a8bb686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8bb686",
  null
  
)

export default component.exports